(() => {
  const sections = document.querySelectorAll('[data-arn-collection-v2]');

  if (!sections.length) return;

  const addVariant = async (variantId, quantity = 1) => {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: Number(quantity)
      })
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.description || 'Could not add product to cart.');
    }

    return response.json();
  };

  // Hand the add back to the theme's own cart flow. Archetype Motion rebuilds
  // the drawer from /cart.js and slides it open when 'added.ajaxProduct' fires
  // on the body, the same event its native add-to-cart buttons use. This theme
  // has no Dawn-style <cart-drawer> element and does not listen for
  // cart:refresh / cart:updated, so triggering those did nothing. If jQuery is
  // missing for any reason, fall back to the cart page so an add is never lost.
  const refreshThemeCart = () => {
    const jq = window.jQuery || window.$;

    if (jq && jq.fn) {
      jq('body').trigger('added.ajaxProduct');
      return;
    }

    window.location = '/cart';
  };

  sections.forEach((section) => {
    const anchorLinks = section.querySelectorAll('[data-arn-anchor-link]');
    const targetSections = [
      section.querySelector('#arn-shop-all'),
      section.querySelector('#arn-full-size-bars'),
      section.querySelector('#arn-mini-bars'),
      section.querySelector('#arn-variety-packs')
    ].filter(Boolean);

    const setActiveLink = (id) => {
      anchorLinks.forEach((link) => {
        const href = link.getAttribute('href') || '';
        link.classList.toggle('is-active', href === `#${id}`);
      });
    };

    anchorLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        const href = link.getAttribute('href');

        if (!href || !href.startsWith('#')) return;

        const target = section.querySelector(href);

        if (!target) return;

        event.preventDefault();

        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });

        setActiveLink(target.id);
      });
    });

    if ('IntersectionObserver' in window && targetSections.length) {
      const observer = new IntersectionObserver(
        (entries) => {
          const visibleEntries = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

          if (visibleEntries.length) {
            setActiveLink(visibleEntries[0].target.id);
          }
        },
        {
          root: null,
          threshold: [0.18, 0.28, 0.4],
          rootMargin: '-18% 0px -66% 0px'
        }
      );

      targetSections.forEach((target) => observer.observe(target));
    }

    const quickAddButtons = section.querySelectorAll('[data-arn-quick-add]');

    quickAddButtons.forEach((button) => {
      button.addEventListener('click', async () => {
        const variantId = button.getAttribute('data-variant-id');
        const defaultText = button.getAttribute('data-default-text') || 'Add a box';
        const loadingText = button.getAttribute('data-loading-text') || 'Adding';
        const addedText = button.getAttribute('data-added-text') || 'Added';

        if (!variantId || button.classList.contains('is-loading')) return;

        const textNode = button.querySelector('span') || button;

        button.classList.add('is-loading');
        button.disabled = true;
        textNode.textContent = loadingText;

        try {
          await addVariant(variantId, 1);

          button.classList.remove('is-loading');
          button.classList.add('is-added');
          textNode.textContent = addedText;

          refreshThemeCart();

          setTimeout(() => {
            button.classList.remove('is-added');
            button.disabled = false;
            textNode.textContent = defaultText;
          }, 1600);
        } catch (error) {
          console.error(error);

          button.classList.remove('is-loading');
          button.disabled = false;
          textNode.textContent = 'Try again';

          setTimeout(() => {
            textNode.textContent = defaultText;
          }, 1600);
        }
      });
    });
  });
})();